// El carrito del escaparate, guardado en el navegador.
//
// POR QUE SOBREVIVE A RECARGAR (CA-K2). Quien arma un pedido en el móvil,
// de pie en un mostrador o en el camión, cambia de pestaña, le entra una
// llamada o se le bloquea la pantalla. Un carrito que se pierde con eso
// no se vuelve a armar: se abandona. Y a diferencia de una sesión, aquí no
// hay cuenta donde guardarlo — es del navegador o no es de nadie.
//
// SE GUARDA POR TIENDA Y POR SUCURSAL. El precio y la existencia son de
// una sucursal concreta; mezclar el carrito de dos sería armar un pedido
// que no se puede recoger en ninguna.
//
// NO SE GUARDA EL PRECIO. Solo qué y cuánto. El precio bueno es el del
// mostrador en el momento del cobro, y guardarlo aquí invitaría a
// enseñarle al cliente un total que el sistema no va a respetar.

const PREFIJO = 'tego_carrito';

function llave(clave, sucursal) {
  return `${PREFIJO}:${clave}:${sucursal}`;
}

export function leer(clave, sucursal) {
  if (!clave || !sucursal) return [];
  try {
    const crudo = localStorage.getItem(llave(clave, sucursal));
    const datos = crudo ? JSON.parse(crudo) : [];
    // LO QUE HAY EN `localStorage` NO ES DE FIAR: lo puede haber escrito
    // una versión anterior, otra pestaña, o alguien a mano. Se valida
    // renglón por renglón en vez de confiar en que tenga la forma
    // esperada — un carrito corrupto no puede dejar la tienda en blanco.
    return Array.isArray(datos)
      ? datos.filter((r) => r && typeof r.sku === 'string' && Number(r.cantidad) > 0)
        .map((r) => ({ sku: r.sku, nombre: String(r.nombre || r.sku),
                       cantidad: Number(r.cantidad) }))
      : [];
  } catch {
    return [];
  }
}

function guardar(clave, sucursal, renglones) {
  try {
    localStorage.setItem(llave(clave, sucursal), JSON.stringify(renglones));
  } catch {
    // Sin espacio o en modo privado. El carrito sigue funcionando en esta
    // pestaña; solo no sobrevivirá a recargar. Callar aquí es correcto:
    // no hay nada que la persona pueda hacer al respecto, y avisarla de
    // algo que no puede resolver solo estorba.
  }
  return renglones;
}

export function agregar(clave, sucursal, producto, cantidad = 1) {
  const renglones = leer(clave, sucursal);
  const ya = renglones.find((r) => r.sku === producto.sku);
  if (ya) ya.cantidad += cantidad;
  else renglones.push({ sku: producto.sku, nombre: producto.nombre, cantidad });
  return guardar(clave, sucursal, renglones);
}

export function fijar(clave, sucursal, sku, cantidad) {
  const renglones = leer(clave, sucursal)
    .map((r) => (r.sku === sku ? { ...r, cantidad } : r))
    .filter((r) => r.cantidad > 0);
  return guardar(clave, sucursal, renglones);
}

export function quitar(clave, sucursal, sku) {
  return guardar(clave, sucursal, leer(clave, sucursal).filter((r) => r.sku !== sku));
}

export function vaciar(clave, sucursal) {
  return guardar(clave, sucursal, []);
}

export function cuantos(renglones) {
  return renglones.reduce((n, r) => n + r.cantidad, 0);
}
